import React, { Component } from 'react';
import DropDownMobile from 'atoms/dropdown-mobile';
import HundredRatingInfographic from 'atoms/hundred-rating-infographic';
import PropTypes from 'prop-types';


export const HUNDRED_RATING_OPTIONS = {
  CENTER: 'CENTER',
  FIRE: 'FIRE',
  HEART: 'HEART',
  STAR: 'STAR',
};

export default class PageEstablishmentHundredRating extends Component {
  constructor(props) {
    super(props);
    this.onClickBallBinded = this.onClickBall.bind(this);
    const { isPhone, isTablet } = this.props;
    this.state = {
      ball: (isPhone || isTablet) ? HUNDRED_RATING_OPTIONS.FIRE : '',
    };
  }

  onClickBall(ball) {
    this.setState({ ball });
  }

  render() {
    const { partners, adjective, hundredRating, isPhone, partnersRating, t } = this.props;
    const { ball } = this.state;

    const experienceContent = (
      <div className="page-establishment-hundred-rating__list__experience">
        { t('We consider the authentic experiences of guests that have previously enjoyed the accommodation for themselves.') }
      </div>
    );

    const interestContent = (
      <div className="page-establishment-hundred-rating__list__interest">
        { t('Based on its popularity, we consider how attractive a holiday rental might be.') }
      </div>
    );

    const ratingContent = (
      <div className="page-establishment-hundred-rating__list__ratings">
        <span className="page-establishment-hundred-rating__list__ratings__text">
          { t('We gather ratings for the same accommodation from various booking websites.') }
        </span>
        <div className="page-establishment-hundred-rating__list__ratings__partners">
          { partners.map(partner => (
            Object.keys(partnersRating || {}).includes(partner.id.toString()) && partnersRating[partner.id]
              ? (
                <span key={ `partner_${partnersRating[partner.id]}` } className="page-establishment-hundred-rating__list__ratings__partners__partner">
                  <span className="page-establishment-hundred-rating__list__ratings__partners__partner__name">
                    { partner.visibleName }
                  </span>
                  <span className="page-establishment-hundred-rating__list__ratings__partners__partner__number">
                    { partnersRating[partner.id] }
                  </span>
                </span>)
              : null
          ))
          }
        </div>
      </div>
    );

    return (
      <div className="page-establishment-hundred-rating">
        <div className="page-establishment-hundred-rating__title">
          {" Hundred Rating "}
        </div>
        <div className="page-establishment-hundred-rating__text">
          { ` ${t('Our ratings are based on guest experience, existing ratings from booking sites and what the user is looking for in their holiday rental.')}` }
        </div>
        <HundredRatingInfographic
          adjective={ adjective }
          hundredRating={ hundredRating }
          onSubmit={ this.onClickBallBinded }
          t={ t }
        />
        <ul className="page-establishment-hundred-rating__list">
          <li>
            <DropDownMobile
              content={ experienceContent }
              image="/img/hundred-rating/icon-heart.svg"
              isPhone={ isPhone }
              title={ t('Guest experience') }
              toggle={ ball === HUNDRED_RATING_OPTIONS.HEART }
            />
          </li>
          <li>
            <DropDownMobile
              content={ interestContent }
              image="/img/hundred-rating/icon-fire.svg"
              isPhone={ isPhone }
              title={ t('Interest of users') }
              toggle={ ball === HUNDRED_RATING_OPTIONS.FIRE }
            />
          </li>
          <li>
            <DropDownMobile
              content={ ratingContent }
              image="/img/hundred-rating/icon-star.svg"
              isPhone={ isPhone }
              title={ t('Ratings on other websites') }
              toggle={ ball === HUNDRED_RATING_OPTIONS.STAR }
            />
          </li>
        </ul>
      </div>
    );
  }
}

PageEstablishmentHundredRating.defaultProps = {
  adjective: '',
  isPhone: false,
  isTablet: false,
  partnersRating: {},
};

PageEstablishmentHundredRating.propTypes = {
  adjective: PropTypes.string,
  hundredRating: PropTypes.number.isRequired,
  isPhone: PropTypes.bool,
  isTablet: PropTypes.bool,
  partners: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  partnersRating: PropTypes.shape(),
  t: PropTypes.func.isRequired,
};
